/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ImportJobRequest
 */
export interface ImportJobRequest {
    /**
     * 
     * @type {string}
     * @memberof ImportJobRequest
     */
    content: string;
    /**
     * 
     * @type {boolean}
     * @memberof ImportJobRequest
     */
    replace: boolean;
    /**
     * 
     * @type {string}
     * @memberof ImportJobRequest
     */
    rename?: string | null;
}

export function ImportJobRequestFromJSON(json: any): ImportJobRequest {
    return ImportJobRequestFromJSONTyped(json, false);
}

export function ImportJobRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportJobRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'content': json['content'],
        'replace': json['replace'],
        'rename': !exists(json, 'rename') ? undefined : json['rename'],
    };
}

export function ImportJobRequestToJSON(value?: ImportJobRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'content': value.content,
        'replace': value.replace,
        'rename': value.rename,
    };
}


